import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 2,
  class: "actions"
}
const _hoisted_5 = {
  key: 3,
  class: "actions"
}

interface PropsType {
	show?: boolean;
	title?: string;
	width?: string;
	showButtonConfirm?: boolean;
	buttonConfirm?: string;
	buttonClose?: string;
	buttonType?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'base-modal',
  props: {
    show: { type: Boolean, default: false },
    title: { default: "" },
    width: { default: "80%" },
    showButtonConfirm: { type: Boolean, default: false },
    buttonConfirm: { default: "Confirmar" },
    buttonClose: { default: "Fechar" },
    buttonType: { default: "default" }
  },
  emits: ["close", "confirm"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", {
            class: "modal-body shadow",
            style: _normalizeStyle({ width: __props.width })
          }, [
            (_ctx.$slots.title)
              ? _renderSlot(_ctx.$slots, "title", {}, undefined, undefined, 0)
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (__props.title)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "title",
                        innerHTML: __props.title
                      }, null, 8, _hoisted_2))
                    : _createCommentVNode("", true)
                ], 64)),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "content")
            ]),
            (_ctx.$slots.actions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _renderSlot(_ctx.$slots, "actions")
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (__props.showButtonConfirm)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-primary btn-md",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
                      }, _toDisplayString(__props.buttonConfirm), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn btn-default btn-md",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
                  }, _toDisplayString(__props.buttonClose), 1)
                ]))
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})